export default __webpack_public_path__ + "static/media/dark_blue.6b70bf50.jpg";